import React, {useCallback, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {usePresentationParams} from '../../../../../hooks/usePresentationParams';
import {roomProtectionSelector} from '../../../../../store/selectors/roomProtection.selector';
import {findRoomByIdAction} from '../../../../../store/actions/roomRunFile.actions';
import IdentificationModal from '../../../../../components/presentationView/parts/components/IdentificationModal';
import {ProtectionType} from '../../../../../incase-domain/presentationProtection';
import UserAuthModal from '../../../../../components/presentationView/parts/components/UserAuthModal';
import {GuestCredentials} from '../../../../../components/presentationView/parts/components/GuestModal';

function UserCredentialsModal(): JSX.Element {
    const {isRoomAdmin, roomId, params} = usePresentationParams();
    const dispatch = useDispatch();

    const protection = useSelector(roomProtectionSelector);

    useEffect(() => {
        const isGuestOnly = protection?.protectionTypes.length === 1 && protection.protectionTypes.includes(ProtectionType.GUEST);

        if (roomId && isGuestOnly && !isRoomAdmin) {
            dispatch(findRoomByIdAction(roomId, undefined, params));
        }
    }, [dispatch, params, roomId, protection, isRoomAdmin]);

    const findPresentation = useCallback(
        (cr?: GuestCredentials): void => {
            if (roomId) {
                dispatch(findRoomByIdAction(roomId, cr, params));
            }
        },
        [dispatch, params, roomId]
    );

    return (
        <>
            <UserAuthModal protection={protection} findPresentation={findPresentation} />
            <IdentificationModal />
        </>
    );
}

export default UserCredentialsModal;
